// react-router components
import { Link } from "react-router-dom";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const date = new Date().getFullYear();

function VeroFooter() {
  return (
    <MKBox px={2} mx={2} textAlign="center">
      <MKBox display="flex" justifyContent="center" gap={3} mb={1}>
        <MKTypography component={Link} to="/projects" variant="button" color="text">
          Projects
        </MKTypography>
        <MKTypography component={Link} to="/history" variant="button" color="text">
          History
        </MKTypography>
        <MKTypography component={Link} to="/contact" variant="button" color="text">
          Contact
        </MKTypography>
      </MKBox>
      <MKTypography variant="button" fontWeight="regular" textAlign="center">
        All rights reserved. Copyright &copy; {date} Vero Software, LLC.
      </MKTypography>
    </MKBox>
  );
}

export default VeroFooter;
